import './App.css';
import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import Landing from "./pages/landing";
import PrivacyPolicy from "./pages/privacypolicy";
import Support from "./pages/support";
import Motivations from "./pages/motivations";
import { Analytics } from "@vercel/analytics/react"
import HowToUse from "./pages/howtouse";
import PatientInfo from "./pages/patient";

class App extends React.Component {
    render() {
        return(
            <div className="App">
                <Routes>
                    <Route path="/" element={<Navigate to="/amii" />} />

                    <Route path="/amii" element={<Landing/> } />
                    <Route path="/amii/howtouse" element={<HowToUse />}/>
                    <Route path="/amii/privacy-policy" element={<PrivacyPolicy/>} />
                    <Route path="/amii/support" element={<Support/> } />
                    <Route path="/amii/motivations" element={<Motivations/> } />
                    <Route path="/amii/patient" element={<PatientInfo/> } />
                </Routes>
                <Analytics />
            </div>
        )
    }
}
export default App;
